import { createAsyncThunk } from '@reduxjs/toolkit';
import { OptinOutData, OptInOutMetaData } from '../interface/inclusive-access.interface';
import { updateInclusiveAccessApiCall } from '../api/inclusive-access.apis';

//temp thunk code for new update api
export const updateInclusiveAccessData = createAsyncThunk(
  'inclusiveAccess/updateInclusiveAccessData',
  async (payload: OptInOutMetaData, thunkAPI) => {
    try {
      var inclusiveAccessData: OptinOutData[] = [];
      const response = await updateInclusiveAccessApiCall(payload);

      inclusiveAccessData = inclusiveAccessData
        .concat(response)
        .sort((a, b) => new Date(b.lastUpdatedDate).getTime() - new Date(a.lastUpdatedDate).getTime());

      return inclusiveAccessData;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);
